<template>
	<div class="videoArr">
		<el-dialog :title="dialogTitle" :close-on-click-modal=false :visible.sync="dialogVisible" width="500px" :close="handleClose" top="8vh">
			<div class="dialogMain">
				<dl>
					<dt><span class="checktip">*&ensp;</span>图片名称：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.name"  class="inputWidth" placeholder="图片名称"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*&ensp;</span>上传图片：</dt>
						  <!--:http-request="hashMd5"
						  :data="fileData"-->
					<dd>
						<el-upload
						  class="upload-demo"
						  ref="upload"
						  :action="'zcvrVideoApi/image/uploadImg/'+session"
						  :before-upload="beforeAvatarUpload"
						  :on-remove="handleRemove"
						  :file-list="fileList"
						  :on-success="uploadSuccess"
						  :on-error="uploadError"
						  :on-change="handleChange"
						  :limit="2"
						  :auto-upload="false">
						  <!--<el-button size="small" type="primary">上传视频</el-button>-->
						  <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
  						 <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传图片</el-button>
						  <span slot="tip" class="el-upload__tip tooltip">只能上传jpg/png文件</span>
						</el-upload>
						<div v-show="dialogData.imgUrl"><img :src="dialogData.imgUrl" class="videoImg"/></div>
					</dd>
				</dl>
				<dl>
					<dt>全景图链接：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.panoramaUrl" placeholder="全景图链接"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">&emsp;&ensp;*</span>上下架：</dt>
					<dd class="cf">
						<el-switch
						  v-model="dialogData.status"
						  active-color="#13ce66"
						  inactive-color="#ff4949">
						</el-switch>
					</dd>
				</dl>
				<dl>
					<dt>&emsp;&emsp;&emsp;描述：</dt>
					<dd class="cf">
						<el-input type="textarea" v-model="dialogData.description" :rows="4" placeholder="描述" ></el-input>
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()":loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<div class="mainBody">
			<div class="filtrateMain">
				<el-button type="primary" size="mini" @click="handleAdd()">新增</el-button>
				<el-button type="danger" size="mini" @click="handleDelete()">删除</el-button>
				<div class="fr">
					<el-input v-model="filtrateData.name" placeholder="图片名称" class="inputWidth1"></el-input>
					<el-button type="primary" size="mini" @click="handleSearch()" class="searchBtn">查询</el-button>
				</div>
			</div>
			<div class="isZero" v-show="tableData.length<=0">暂无视频</div>
			<el-row :gutter="20">
			  	<el-col :xs="12" :sm="10" :md="8" :lg="6" :xl="4" v-for="(item,index) in tableData" :key="index">
		  	 		<div :class="item.status==2?'details translucence':'details'">
						<div class="check">
							<el-checkbox @change="checkFn(item.id, index)" :class="'checked'+index"></el-checkbox>
							<!--<input type="checkbox" name="checkbox" @click="deleteFn(item.id)">-->
						</div>
						<div :class="item.imgUrl!=''?'pic':'picHide'">
							<img :src="item.imgUrl" width="100%" height="100%" v-show="item.imgSrc!=''"/>
							<div :class="item.imgUrl!=''?'show':'imgHide'">{{item.name}}</div>
						</div>
						<div class="cf" :class="item.imgUrl!=''?'remark':'remarkHide'">{{item.description}}</div>
						<div class="foot cf">
							<span class="dateTime fl">{{item.createTime}}</span>
							<a href="javascript:void(0)" class="el-icon-edit fr" @click="handleEdit(item)" style="color: #000;text-decoration: none;"></a>
						</div>
					</div>
			  	</el-col>
			</el-row>
		</div>
		<!--分页-->
		<div class="page">
			<el-pagination
				background
				:current-page="tableDataArr.currentPage"
				:page-sizes="[10,20,30,40]"
				:page-size="tableDataArr.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tableDataArr.totalSize"
		     	@current-change="handleCurrentChange"
		     	@size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import management from './management.vue'
	import navZcy from './nav.vue'
	export default{
		data() {
			return {
				loading: false,
				dialogVisible: false,
				dialogTitle: '',
				dialogData: {
					status:true,
				},
				checked: {},
				filtrateData: {
				},
				tableDataArr: {			//分页
					currentPage: 1,
					pageSize: 10,
					totalSize: 0
				},
				tableData: [],
				fileList: [],
				session: "",
				fileData:{
					videoMd5: ""
				}
			}
		},
		methods: {
			beforeAvatarUpload(file) {
//				console.log(file)
		        const isMP4 = file.type === 'image/jpeg'||'image/png';

		        if (!isMP4) {
		          this.$message.error('上传图片只能是 jpg/png 格式!');
		        }
//		        this.hashMd5(file)
		        return isMP4;
		    },
		    submitUpload(){
//		    	console.log(this.fileList)
		    	$('.el-upload-list').css('height',"29px")
		    	this.$refs.upload.submit();
		    },
		    uploadSuccess(response, file, fileList){
//		    	console.log(response)
				if(response.msg=="ok"){
					this.dialogData.imgUrl = response.data.imgUrl
					this.dialogData.imgMd5 = response.data.imgMd5
					var imgUrlName = this.dialogData.imgUrl.split("/")
				    this.fileList = [{
				    	name: imgUrlName[imgUrlName.length-1]
				    }]
				}else{
					this.$message({
						type: 'error',
						message: response.msg
					});
					if(response.msg=="该SessionId已经超时"){
			  			this.$message.error("登录超时！请重新登录");
			  			this.$router.push({path: '/',query: ''})
			  		}
				}
		    },
		    uploadError(err, file, fileList){
		    	this.$router.push({path: '/',query: ''})
		    },
		    handleChange(files, fileList){
//		    	console.log(fileList)
		    	this.fileList=[]
		    	this.fileList.push(fileList[fileList.length-1])
		    },
			//图片md5值
//			hashMd5(oFile){
//		    	var vue = this
//			   	var fileReader = new FileReader(),
//		        blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
//		        file = oFile,
//		        chunkSize = 2097152,
//		        // read in chunks of 2MB
//		        chunks = Math.ceil(file.size / chunkSize),
//		        currentChunk = 0,
//		        spark = new SparkMD5();
//			    fileReader.onload = function(e) {
//	//		        console.log("read chunk nr", currentChunk + 1, "of", chunks);
//			        spark.appendBinary(e.target.result); // append binary string
//			        currentChunk++;
//
//			        if (currentChunk < chunks) {
//			            loadNext();
//			        }else {
//			        	vue.fileData.videoMd5 = spark.end()
//			        	console.log(vue.fileData)
////						vue.uploadItem(spark.end(),file)
//			        }
//			    };
//			    function loadNext() {
//			        var start = currentChunk * chunkSize,
//			            end = start + chunkSize >= file.size ? file.size : start + chunkSize;
//
//			        fileReader.readAsBinaryString(blobSlice.call(file, start, end));
//			    };
//			    loadNext();
//			},
			handleRemove(file, fileList){
				$('.el-upload-list').css('height','auto')
				this.dialogData.imgUrl = ""
			},
			//上传图片
//			uploadItem(md5,file){
//				let param = new FormData()  // 创建form对象
//			    param.append('file', file, file.name)
//			    param.append('videoMd5', md5)
//				var header = {
//	                'Content-Type': 'multipart/form-data'
//	            }
//				axios.post("zcvrVideoApi/video/uploadVideo/"+sessionStorage.getItem('sessionId'),param,header).then(
//					(success) => {
//						console.log(success)
//						if(success.data.msg=="ok"){
//							console.log("this.fileList")
//							console.log(this.fileList)
//							this.dialogData.videoUrl = success.data.data.videoUrl
//							this.dialogData.imgUrl = success.data.data.imgUrl
//							this.dialogData.videoMd5 = success.data.data.videoMd5
//							var videoUrlName = this.dialogData.videoUrl.split("/")
//						    this.fileList = [{
//						    	name: videoUrlName[videoUrlName.length-1]
//						    }]
//						}else{
//							this.$message({
//								type: 'error',
//								message: success.data.msg
//							});
//							if(success.data.msg=="该SessionId已经超时"){
//					  			this.$message.error("登录超时！请重新登录");
//					  			this.$router.push({path: '/',query: ''})
//					  		}
//						}
//					}
//				)
//			},
			inquiryImg: function(){
				var data = {
					name: this.filtrateData.name==undefined?this.filtrateData.name:this.filtrateData.name.trim(),
					currentPage: this.tableDataArr.currentPage,
					pageSize: this.tableDataArr.pageSize
				}
				this.$http.post("zcvrVideoApi/image/inquiryImg/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
		  			(success)=>{
//		  				console.log(success)
		  				if(success.body.msg!="ok"){
		  					this.tableDataArr = {
								currentPage: 1,
								pageSize: 10,
								totalSize: 0
		  					}
		  					this.tableData = []
							this.$message({
								type: 'error',
								message: success.data.msg
							});
							if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}else {
		  					this.tableDataArr = success.body.data
		  					this.tableData = this.tableDataArr.items
		  				}

		  			},
		  			(error)=>{
		  				console.log("数据连接失败")
		  			}
		  		)
			},
			handleClose: function(done) {
				done();
			},
			handleSearch: function() {
				this.tableDataArr.currentPage = 1
				this.inquiryImg()
			},
			handleAdd: function() {
				this.loading=false
				this.dialogTitle = "新增图片"
				this.dialogData = {
					status:true,
				}
				this.fileList = []
				this.dialogVisible = true
			},
			handleEdit: function(item) {
				this.loading=false
				this.dialogTitle = "编辑图片"
				this.dialogData = {
					id: item.id,
					name: item.name,
					imgMd5: item.imgMd5,
					imgUrl: item.imgUrl,
					panoramaUrl: item.panoramaUrl,
					status: item.status==1?true:false,
					description: item.description
				}
				var imgUrlName = this.dialogData.imgUrl.split("/")
			    this.fileList = [{
			    	name: imgUrlName[imgUrlName.length-1]
			    }]
				this.dialogVisible = true
			},
			handleConfirm: function(){
				var url = ""
				var imgUrl = this.dialogData.imgUrl
				if(imgUrl){
					if(imgUrl.indexOf("http") != -1){
						var imgUrl = imgUrl.split("/")
						imgUrl = imgUrl[imgUrl.length-2]+"/"+imgUrl[imgUrl.length-1]
					}
				}
				var data = {
					name: this.dialogData.name==undefined?this.dialogData.name:this.dialogData.name.trim(),
					imgMd5: this.dialogData.imgMd5,
					imgUrl: imgUrl,
					panoramaUrl: this.dialogData.panoramaUrl,
					status: this.dialogData.status?1:2,
					description: this.dialogData.description
				}
				if(!this.dialogData.id){
					url = "zcvrVideoApi/image/createImg/"+sessionStorage.getItem('sessionId')
				}else{
					data.id = this.dialogData.id
					url = "zcvrVideoApi/image/updateImg/"+sessionStorage.getItem('sessionId')
				}
				this.loading=true
				this.$http.post(url,data,{emulateJson:true}).then(
		  			(success)=>{
//		  				console.log(success)
						this.loading=false
		  				if(success.data.msg=="ok"){
		  					this.dialogVisible = false
		  					this.inquiryImg()
		  				}else {
		  					this.$message({
					          message: success.data.msg,
					          type: 'error'
					        });
			  				if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}
		  			},
		  			(error)=>{
						this.loading=false
						this.$message.error("数据连接失败");
		  			}
		  		)
			},
			checkFn: function(id,index){
				var len = $('.checked'+index+'.is-checked').length
				if(len==1){
					this.checked[id] = false
				}else{
					this.checked[id] = true
				}
			},
			handleDelete: function() {
				var ids = []
				var checked = this.checked
				Object.keys(checked).forEach(function(key){
				    if(checked[key] == true){
				     	ids.push(key)
				    }
				});
//				console.log(ids)
				if(ids.length>0){
					this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$http.get("zcvrVideoApi/image/deleteImg/"+sessionStorage.getItem('sessionId')+"/"+ids,{emulateJson:true}).then(
				  			(success)=>{
//				  				console.log(success)
				  				if(success.body.msg=="ok"){
				  					this.$message({
							          message: '删除成功',
							          type: 'success'
							        });
							        this.checked = {}
				       				$('.el-checkbox__input.is-checked').removeClass('is-checked')
							        this.inquiryImg()
				  				}else{
				  					this.$message({
							          message: success.data.msg,
							          type: 'error'
							        });
					  				if(success.data.msg=="该SessionId已经超时"){
							  			this.$message.error("登录超时！请重新登录");
							  			this.$router.push({path: '/',query: ''})
							  		}
				  				}
				  			},
				  			(error)=>{
				  				console.log("数据连接失败")
				  			}
				  		)
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				}else{
					this.$message({
						type: 'info',
						message: '请选择删除项'
					});
				}
			},
	        //点击页数
			handleCurrentChange(cur) {
				this.tableDataArr.currentPage = cur
				this.inquiryImg()
			},
			//点击改变显示条目
			handleSizeChange(size) {
				this.tableDataArr.pageSize = size
				this.inquiryImg()
			},
		},
		mounted(){
			this.inquiryImg()
			this.session = sessionStorage.getItem('sessionId')
		},
		components: {
			management,
			navZcy
		}
	}
</script>
<style type="text/css">
	a.closeBtn{
		color: #fff;
		font-size: 42px;
	    position: absolute;
	    top: -8px;
		right: 10px;
	    opacity: .9;
	    text-decoration: none;
	}

</style>
<style scoped>
	/*公用的*/
	.fl{
		float: left;
	}
	.fr{
		float: right;
	}
	.cf{
		overflow: hidden;
	}
	.videoOuter{
		width: 100%;
    	height: 100%;
		position: fixed;
		top:0px;
		padding-top: 10%;
		z-index: 1000;
		background: rgba(0,0,0,0.5);
	}
	.video{
		display: inline-block;
		vertical-align: middle;
		width: 80%;
		height: 70%;
		margin: 0 auto;
	}
	.tooltip{
		padding-left: 10px;
	}
	.videoImg{
		width: 200px;
		cursor: pointer;
	}
	.mainBody{
		padding: 20px;
	}
	.filtrateMain{
		padding-bottom: 20px;
	}
	.filtrateMain .searchBtn{
		margin: 0 20px;
	}
	.inputWidth1{
		width: 150px;
		margin-left: 15px;
	}
	.details{
		position: relative;
		margin-bottom: 20px;
		border: 1px solid #eee;
   		box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
	}
	.details.translucence{
		opacity: 0.5;
	}
	.isZero{
		text-align: center;
		padding: 50px;
	}
	.check{
		position: absolute;
		top: 0;
		right: 0;
		z-index: 10;
		background: #fff;
		padding: 0 5px;
	}
	.pic,.picHide{
		cursor: pointer;
		width: 100%;
		overflow: hidden;
	}
	.pic{
		position: relative;
		height: 165px;
	}
	.pic .show{
		position: absolute;
		width:100%;
		bottom: 0;
		left: 0;
		padding: 10px 20px;
		background: rgba(0,0,0,0.2);
		color: #fff;
		font-weight: bold;
		line-height: 25px;
		height: 70px;
	}
	.picHide{
		height: 70px;
	}
	.picHide .imgHide{
		width:100%;
		padding: 10px 20px;
		background: #fff;
		color: #2a72c5;
		font-weight: bold;
		line-height: 25px;
		height: 70px;
		border-bottom: 1px solid #eee;
	}
	.remark{
		margin: 10px 15px;
		height: 60px;
	}
	.remarkHide{
		margin: 10px 15px;
		height: 155px;
		overflow-wrap: break-word;
	}
	.foot{
		padding: 10px 15px;
		border-top: 1px solid #eee;
	}
	.dateTime{
	    color: #838383;
	    font-size: 10px;
	    line-height: 20px;
	    margin-bottom: 0px;
	}
	.page{
		text-align: center;
	}
</style>
